module.exports = __webpack_public_path__ + "img/444.d0e7aaf4.jpg";